import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';

import { PortalServico } from './portal-servico.model';

@Injectable({ providedIn: 'root' })
export class PortalServicoService extends BaseService {
    readonly PATH = environment.basePath + '/portal/servico';

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    /** Lista todos os serviços do portal (todas as UFs) — `GET /portal/servico/TODAS`. */
    listarTodos(): Observable<PortalServico[]> {
        return this.listarPorUf('TODAS');
    }

    /**
     * Lista os serviços do portal de uma UF — `GET /portal/servico/{uf}`.
     * @param divulga filtro opcional por divulgação (`true` = divulgados; `false` = não divulgados; omitido = todos).
     */
    listarPorUf(uf: string, divulga?: boolean): Observable<PortalServico[]> {
        let params = new HttpParams();
        if (divulga !== undefined) {
            params = params.set('divulga', divulga);
        }
        return this.http.get<PortalServico[]>(`${this.PATH}/${encodeURIComponent(uf)}`, { params });
    }

    /** Cadastra ou atualiza um serviço — `POST /portal/servico` (upsert por `codigo`). */
    salvar(request: PortalServico): Observable<PortalServico> {
        return this.http.post<PortalServico>(this.PATH, request);
    }

    /** Exclui um serviço pelo código (ID_WEB_EXTERNO) — `DELETE /portal/servico/{codigo}`. */
    remover(codigo: number): Observable<void> {
        return this.http.delete<void>(`${this.PATH}/${codigo}`);
    }
}
